import React, {useEffect, useState} from 'react';
import {getD365HourLogs} from '../../api/d365Api';
import {reverse, sortBy} from 'lodash';
import {HourLogTable} from "./HourLogTable";

const HourLog = ({exp}) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);


  const load = async () => {
    try {
      setLoading(true);
      const logs = await getD365HourLogs(exp.ID);
      const sorted = reverse(sortBy(logs, r => r.CreatedAt));
      setLogs(sorted);
    } catch (e) {
      console.error(`Could not get logs Export ${exp.filename}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, []);

  return (
    <HourLogTable
      hourLog={logs}
      loading={loading}
      projectSearch={false}
      isModal={true}
    />
  );
};

export {HourLog};